/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 137
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  GeoJson,
  ShapesImportPost200Response,
  ShapesListGet200Response,
} from '../models';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GeoJsonFromJSON,
    GeoJsonToJSON,
    ShapesImportPost200ResponseFromJSON,
    ShapesImportPost200ResponseToJSON,
    ShapesListGet200ResponseFromJSON,
    ShapesListGet200ResponseToJSON,
} from '../models';

export interface ShapesExportIdGetRequest {
    id: string;
    format: string;
    dc?: string;
}

export interface ShapesIdDeleteRequest {
    id: string;
}

export interface ShapesIdGetRequest {
    id: string;
}

export interface ShapesIdPutRequest {
    id: string;
    json: GeoJson;
}

export interface ShapesImportPostRequest {
    name: string;
    type: string;
    body: Blob;
    parent?: string;
}

export interface ShapesPostRequest {
    json: GeoJson;
}

/**
 * 
 */
export class ShapesApi extends runtime.BaseAPI {

    /**
     * Export shape definition in the specified format.
     * Export shape definition
     */
    async shapesExportIdGetRaw(requestParameters: ShapesExportIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shapesExportIdGet.');
        }

        if (requestParameters.format === null || requestParameters.format === undefined) {
            throw new runtime.RequiredError('format','Required parameter requestParameters.format was null or undefined when calling shapesExportIdGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.format !== undefined) {
            queryParameters['format'] = requestParameters.format;
        }

        if (requestParameters.dc !== undefined) {
            queryParameters['_dc'] = requestParameters.dc;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/shapes/export/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Export shape definition in the specified format.
     * Export shape definition
     */
    async shapesExportIdGet(requestParameters: ShapesExportIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.shapesExportIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete the shape corresponding to the id.
     * Delete a shape
     */
    async shapesIdDeleteRaw(requestParameters: ShapesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shapesIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/shapes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Delete the shape corresponding to the id.
     * Delete a shape
     */
    async shapesIdDelete(requestParameters: ShapesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.shapesIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return the shape definition corresponding to the id.
     * Return the shape definition.
     */
    async shapesIdGetRaw(requestParameters: ShapesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeoJson>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shapesIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/shapes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeoJsonFromJSON(jsonValue));
    }

    /**
     * Return the shape definition corresponding to the id.
     * Return the shape definition.
     */
    async shapesIdGet(requestParameters: ShapesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeoJson> {
        const response = await this.shapesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the shape corresponding to the id.
     * Update a shape
     */
    async shapesIdPutRaw(requestParameters: ShapesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shapesIdPut.');
        }

        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling shapesIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/shapes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GeoJsonToJSON(requestParameters.json),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Update the shape corresponding to the id.
     * Update a shape
     */
    async shapesIdPut(requestParameters: ShapesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.shapesIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Import shape definitions from the provided data.
     * Import shape definitions
     */
    async shapesImportPostRaw(requestParameters: ShapesImportPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShapesImportPost200Response>> {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling shapesImportPost.');
        }

        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type','Required parameter requestParameters.type was null or undefined when calling shapesImportPost.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling shapesImportPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.parent !== undefined) {
            queryParameters['parent'] = requestParameters.parent;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/octet-stream';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/shapes/import`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShapesImportPost200ResponseFromJSON(jsonValue));
    }

    /**
     * Import shape definitions from the provided data.
     * Import shape definitions
     */
    async shapesImportPost(requestParameters: ShapesImportPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShapesImportPost200Response> {
        const response = await this.shapesImportPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return the shape definitions.
     * Return all shape definitions available to the user.
     */
    async shapesListGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShapesListGet200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/shapes/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShapesListGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Return the shape definitions.
     * Return all shape definitions available to the user.
     */
    async shapesListGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShapesListGet200Response> {
        const response = await this.shapesListGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Create a shape. Notice the parent_id can be provided as {\"properties\":{\"parent_id\":<uuid>}}. If no parent_id is provided then the shape object is stored in the root
     * Create a shape.
     */
    async shapesPostRaw(requestParameters: ShapesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling shapesPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/shapes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GeoJsonToJSON(requestParameters.json),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Create a shape. Notice the parent_id can be provided as {\"properties\":{\"parent_id\":<uuid>}}. If no parent_id is provided then the shape object is stored in the root
     * Create a shape.
     */
    async shapesPost(requestParameters: ShapesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.shapesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
